import { useIsCompactScreen } from '@/styles/hooks/useIsCompactScreen';

import { useEstateWaterfallContext } from '../contexts/estateWaterfall.context';

export function useIsCompactLayout() {
  const isCompactScreen = useIsCompactScreen();
  const { state } = useEstateWaterfallContext();

  return isCompactScreen || state.derivedData.isSummaryPanelOpen;
}
